import hyperdom from 'hyperdom'
import formatDate from 'root-packages/dates/formatDate.js'
import formats from 'root-packages/dates/formats.js'
import {Sidebar} from '../defaultFlow/index.js'

export default class SidebarDayTour extends Sidebar {
  constructor (options) {
    super(options)
  }

  renderTripDetail (startOrEnd) {
    const renderTripDetailDates = () => {
      return startOrEnd === 'start'
        ? formatDate(this.departure.startDate, formats.human)
        : formatDate(this.departure.endDate, formats.human)
    }

    const renderTripDetailsPlace = () => {
      return startOrEnd === 'start'
        ? `${this.departure.startPlace.city}, ${this.departure.startPlace.country}`
        : `${this.departure.endPlace.city}, ${this.departure.endPlace.country}`
    }
    const renderTripDetailTitle = () => {
      return startOrEnd === 'start'
        ?'Trip Start'
        :'Trip End'
    }
    return <div className="booking-summary__container booking-summary__departure">
      <div className="booking-summary__icon -new-ui_calendar"></div>
      <div className="booking-summary__desc">
        <div className="booking-summary__title">{renderTripDetailTitle()}</div>
        <p className="booking-summary__date booking-summary__date__item booking-summary__date__depart_origin_country">
          {this.progress.tourLoaded ? renderTripDetailDates() : ''}
        </p>
        <p
          className="booking-summary__location booking-summary__location__start booking-summary__location__origin_country">
          {renderTripDetailsPlace()}
        </p>
      </div>
    </div>
  }
}
